import React, { useCallback } from 'react'
import { Util } from '@leverege/api-attributes'
import { Button, Dialog, Dialogs } from '@leverege/ui-elements'
import StringUtil from '@leverege/string-util'
import SimAttributeView from './SimAttributeView'

import S from './style.css'

export default function AttributeView( props ) {
  const { node : attr, device, deviceData, controller, cxt = {}, opts = {}, showName = true } = props
  const ids = Util.getPathIds( attr.path )
  const colls = Util.getPathCollections( attr.path )
  const resPath = Util.getResolvedPath( attr.path, cxt, ids, colls )
  
  const key = `view-${device.id}-${attr.id}-${resPath}`
  const name = StringUtil.capitalizeAll( attr.name )
  // Path.valueAtPath( attr.path, deviceData, undefined )
  const v = deviceData ? Util.getAccessor( attr )( deviceData, undefined, cxt ) : null

  const onSetValue = opts.onSetValue || controller.onSetValue

  const onClear = useCallback( ( e ) => {
    const onClose = Dialogs.show( {
      component : Dialog.Question,
      props : {
        title : 'Delete Value',
        okay : 'Delete',
        message : `Are you sure you want to delete the value at "${attr.path}"?`,
        onOkay : ( e ) => {    
          onSetValue( { attribute : attr, cxt, path : attr.path, value : null } )
          onClose()
        }, 
        onCancel : () => { onClose() }
      }
    } )

  }, [ attr, cxt, onSetValue ] )

  return (
    <>
      { showName && <span className={S.attrViewLabel}>{attr.name}</span> }
      <SimAttributeView
        style={{ backgroundColor : 'white' }}
        cxt={cxt}
        key={key} 
        simulated={isSimulated( device )}
        device={device}
        updaters={controller.state.updaters} 
        attribute={attr}
        name={name} 
        value={v} 
        onSetValue={onSetValue}
        onSetUpdater={controller.onUpdaterChanged}/>
      <div className={S.flexRight}>
        <div className={S.attrViewPath}>{attr.path}</div>
        <Button 
          variant="link"
          icon="fa fa-times fa-fw" 
          disabled={v == null}
          eventData={attr.path}
          onClick={onClear} />
      </div>

    </>
  )
}

function getSimulatorId( device ) {
  const snid = device && device.simNetworkId
  if ( snid ) {
    return device.networkAliases && device.networkAliases[snid] && device.networkAliases[snid].id
  }
  return null
}

function isSimulated( device ) {
  return getSimulatorId( device ) != null
}
